import type { Contact } from "@domaddress/shared";

/** Groepsnamen op een contactkaart, met (vz) bij voorzitter in die groep. */
export default function ContactGroupBadges({ contact }: { contact: Contact }) {
  if (!contact.groups?.length) return null;

  return (
    <>
      {contact.groups.map((g) => (
        <span
          key={g.id}
          className={`group-badge${g.role === "voorzitter" ? " group-badge--chair" : ""}`}
          title={
            g.role === "voorzitter"
              ? `Voorzitter van ${g.name}`
              : g.role === "lid"
                ? `Lid van ${g.name}`
                : g.name
          }
        >
          {g.name}
          {g.role === "voorzitter" ? " (vz)" : ""}
        </span>
      ))}
    </>
  );
}
